<template>
  <el-form-item
    :label="label"
    class="user-id"
    :prop="prop"
    :rules="rules"
  >
    <el-autocomplete
      v-model="userId"
      :clearable="true"
      :maxlength="7"
      :placeholder="placeholder"
      :disabled="disabled"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import AutocompleteFilter from '@/mixins/AutocompleteFilter.vue'
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    AutocompleteFilter,
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: 'ユーザーID'
    },
    prop: {
      type: String,
      default: 'user_id'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '半角英数（最大7文字）'
    }
  },
  computed: {
    userId: {
      get () {
        return this.value
      },
      set (userId) {
        this.$emit('input', userId.toUpperCase())
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
          rules.push(this.validatorHalfUCaseAlphabetNumber(this.label, 'blur'))
        }
        return rules
      }
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.user-id {
  ::v-deep .el-form-item__content {
    width: 12em;
  }
}
</style>
